import {Collection} from '../types/Collection';
import {AddCollectionItemDto, CollectionItem} from '../types/CollectionItem';
import {handleError} from '../../../common/utils/errorHandling';
import httpClient from '../../../common/services/httpClient';

class CollectionsService {
  public async getAllCollections(): Promise<Collection[]> {
    return handleError(
      () => httpClient.get<Collection[]>('/collections'),
      'Error fetching collections:',
      () => []
    );
  }

  public async getPublicCollections(): Promise<Collection[]> {
    return handleError(
      () => httpClient.get<Collection[]>('/collections/public'),
      'Error fetching public collections:',
      () => []
    );
  }

  public async getCollection(id: string): Promise<Collection> {
    return handleError(
      () => httpClient.get<Collection>(`/collections/${id}`),
      'Error fetching collection:'
    );
  }

  public async createCollection(collection: Omit<Collection, 'id'>): Promise<void> {
    const collectionWithId = {
      ...collection,
      id: crypto.randomUUID()
    };
    return handleError(
      () => httpClient.post<void>('/collections', collectionWithId),
      'Error creating collection:'
    );
  }

  public async updateCollection(collection: Collection): Promise<void> {
    return handleError(
      () => httpClient.put<void>(`/collections/${collection.id}`, collection),
      'Error updating collection:'
    );
  }

  public async deleteCollection(id: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/collections/${id}`),
      'Error deleting collection:'
    );
  }

  public async addItemToCollection(collectionId: string, artisticObjectId: string): Promise<void> {
    const dto: AddCollectionItemDto = { artisticObjectId };
    return handleError(
      () => httpClient.post<void>(`/collections/${collectionId}/items`, dto),
      'Error adding item to collection:'
    );
  }

  public async getCollectionItems(collectionId: string): Promise<CollectionItem[]> {
    return handleError(
      () => httpClient.get<CollectionItem[]>(`/collections/${collectionId}/items`),
      'Error fetching collection items:',
      () => []
    );
  }

  public async removeItemFromCollection(collectionId: string, itemId: string): Promise<void> {
    return handleError(
      () => httpClient.delete<void>(`/collections/${collectionId}/items/${itemId}`),
      'Error removing item from collection:'
    );
  }
}

const collectionsService = new CollectionsService();
export default collectionsService;

